import { render, staticRenderFns } from "./ArticlesOverviewModal.vue?vue&type=template&id=0617713a&scoped=true"
import script from "./ArticlesOverviewModal.vue?vue&type=script&lang=js"
export * from "./ArticlesOverviewModal.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOverviewModal.vue?vue&type=style&index=0&id=0617713a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617713a",
  null
  
)

export default component.exports